import { useTranslation } from 'react-i18next';

import { useReport } from './hooks/use-context';
import { HeaderData } from './types';

export function Header({ formName }: { formName?: string }) {
  const { header, body } = useReport();
  const { t } = useTranslation();
  const data = header as HeaderData;

  const item = Array.isArray(body) ? body[0] : (body as any);
  let participanteQuestion: any = null;
  item?.sections?.forEach((section: any) => {
    const q = section?.questions?.find(
      (q: any) =>
        q.id === 'a7cab7cf-d316-4ca5-b510-043406ad2d6a' ||
        q.name?.toLowerCase()?.includes('tst responsável') ||
        q.name?.toLowerCase()?.includes('tst responsavel') ||
        q.name?.toLowerCase()?.includes('participante') ||
        q.name?.toLowerCase()?.includes('colaborador') ||
        q.name?.toLowerCase()?.includes('preenchido por'),
    );
    if (q) participanteQuestion = q;
  });

  const getAnswerText = (question: any) => {
    const answer = question?.answers?.[0];
    if (!answer) return '';
    if (answer.option) return answer.option;
    if (answer.content) return answer.content;
    const nameProp = answer.collection_item?.properties?.find(
      (p: any) => p.name.toLowerCase() === 'name',
    );
    return nameProp?.content || '';
  };

  const participanteText = getAnswerText(participanteQuestion);

  const cellStyle = {
    padding: '8px',
    border: '1px solid black',
    textAlign: 'center' as const,
    verticalAlign: 'middle' as const,
  };

  const getStatus = (status: string) => {
    switch (status) {
      case 'done':
        return 'Finalizado';
      case 'pending':
        return 'Pendente';
      case 'started':
        return 'Iniciado';
      case 'draft':
        return 'Rascunho';
      case 'rescheduled':
        return 'Reagendado';
      case 'incomplete':
        return 'Incompleto';
      case 'delayed':
        return 'Atrasado';
      default:
        return status;
    }
  };

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '3fr 5fr 3fr',
        border: '1px solid black',
        borderBottom: 'none',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <div
        style={{
          ...cellStyle,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {data.logo ? (
          <img
            src={data.logo}
            alt="Logo"
            style={{ maxWidth: '100px', maxHeight: '50px' }}
          />
        ) : (
          <div style={{ fontWeight: 'bold' }}>Logo</div>
        )}
      </div>

      <div
        style={{
          ...cellStyle,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <div style={{ fontSize: '14px', fontWeight: 'normal' }}>
          {t('pdf_report.form')}
        </div>
        <div style={{ marginTop: '4px', fontSize: '18px', fontWeight: 'bold' }}>
          Registro de Desvios - Novo
        </div>
        {participanteText && (
          <div
            style={{ marginTop: '4px', fontSize: '14px', fontWeight: 'normal' }}
          >
            TST Responsável: {participanteText}
          </div>
        )}
      </div>

      <div
        style={{
          ...cellStyle,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          fontSize: '14px',
          textAlign: 'left',
          paddingLeft: '16px',
        }}
      >
        <div style={{ marginBottom: '4px' }}>
          <strong>Data/Hora de Início:</strong> {data.event_date_time}
        </div>
        <div style={{ marginBottom: '4px' }}>
          <strong>Data/Hora de Fim:</strong> {data.event_finished_at || '-'}
        </div>
        <div>
          <strong>Status:</strong> {getStatus(data.status)}
        </div>
      </div>
    </div>
  );
}
